<template>
  <!-- Navigation Bar -->
  <header
    class="unselectable"
    :class="{ fixed: !navFixed }"
  >
    <ul :style="ulStyle">
      <li>
        <a v-link="{ path: '/' }">
          <img
            src="../assets/logo.png"
            style="height: 20px; whith: 120px; margin-bottom: -5px;"
            alt="UmiUni北美校友圈"
          >
          <h1 style="display:inline-block;font-size:12px;padding:0;margin:0;margin-left:-10px"><span style="display: none;">UmiUni</span>北美校友圈</h1>
        </a>
      </li>


      <a
        class="mobile-only navigation-button"
        @click="toggleQR()"
      >
        <img
          width="10%"
          height="10%"
          class="school-logo"
          :src="OSS + 'app_images/wechat_mini_iconLogo'"
        >
      </a>


      <a
        class="mobile-only navigation-button"
        onclick="window.location.href='https://itunes.apple.com/us/app/umiuni/id1265697567?mt=8'"
      >
        <img
          width="10%"
          height="10%"
          class="school-logo"
          :src="OSS + 'app_images/iphone_app_storeLogo'"
        >
      </a>

      <!-- <li class="classification pc-only">
        <a><Icon type="navicon"></Icon>&nbsp;&nbsp;分类
          <ul class="dropdown">
            <li
              v-for="type in keys(types)"
              @click="query.type = type"
            >
              <div class="hr">
                <span v-link="{ name: 'search', query: { type: type } }">{{ types[type] }}</span>
              </div>
              <div
                v-if="tagList"
                class="tag-list"
              >
                <span
                  v-for="tag in tagList[type]"
                  v-link="{ name: 'search', query: { type: type, tag: tag } }"
                >{{ tag }}</span>
              </div>
            </li>
          </ul>
        </a>
      </li>

      <li class="pc-only">
        <a v-link="{ name: 'search', query: { type: 'event' } }"><Icon type="beer"></Icon>&nbsp;&nbsp;活动</a>
      </li> -->

      <li class="pc-only">
        <div class="search-bar-container">
          <div class="search-bar">
            <input
              v-model="query.name"
              class="search-content"
              autocomplete="off"
              type="text"
              placeholder="名称"
              @keyup.enter="search"
            >
            <a class="search-type">
              {{ types[query.type] }}
              <ul class="dropdown">
                <li
                  v-for="type in keys(types)"
                  @click="query.type = type"
                >{{ types[type] }}</li>
              </ul>
            </a>

            <Icon
              v-if="!typeMenuToggle"
              type="ios-arrow-down"
            ></Icon>
            <Icon
              v-else
              type="ios-arrow-up"
            ></Icon>
            <button
              v-link="{ name: 'search', query: query }"
              class="search-btn"
              data-market="搜索栏;搜索Button"
            >
              <Icon type="search"></Icon> {{ $t(`operate.search`) }}
            </button>
          </div>
        </div>
      </li>




      <li class="right pc-only">
        <div class="button-group">
          <a
            v-link="{ path: '/sell' }"
            class="button"
          >发布</a>
        </div>
      </li>

      <li
        v-if="login && info.authority == 2 && false"
        class="right pc-only"
      >
        <a
          v-link="{ name: 'message' }"
          class="line"
        >
          <Badge>
            <span><Icon
              type="ios-email-outline"
              size="24"
            ></Icon></span>
          </Badge>
        </a>
      </li>

      <!-- <li class="right pc-only" v-if="login">
                <a v-link="{ path: '/user/like' }" class="line">
                    <Icon type="ios-heart-outline"></Icon>
                    {{ $t('user.like') }}
                </a>
            </li> -->
      <!-------- 用户登录前 start---------->
      <li
        v-if="!login"
        class="right pc-only"
      >
        <a
          v-link="{ path: '/signup' }"
          class="line"
        >
          {{ $t('user.signup') }}
        </a>
      </li>

      <li
        v-if="!login"
        class="right pc-only"
      >
        <a
          v-link="{ path: '/login' }"
          class="line user"
        >
          {{ $t('user.login') }}
        </a>
      </li>
      <!-------- 用户登录前 end---------->

      <!-------- 用户登录后 start---------->
      <li
        v-if="login"
        v-clickoutside="handleMenuClickOutSide"
        class="right pc-only"
      >
        <a
          class="line user"
          @click="menuToggle = !menuToggle"
        >
          <div
            class="avatar"
            :style="{ backgroundImage: `url(${OSS + info.avatar})` }"
          ></div>

          <span>{{ info.username }}</span>
                    &nbsp;<Icon type="ios-arrow-down"></Icon>
        </a>
        <ul
          class="dropdown"
          :class="{ active: menuToggle }"
          @click="menuToggle = false"
        >
          <li v-link="{ path: '/user/profile' }">
            <Icon
              type="person"
              class="menu-icon"
            ></Icon>{{ $t(`user.profile`) }}
          </li>
          <li v-link="{ path: '/user/forum' }">
            <Icon
              type="chatboxes"
              class="menu-icon"
            ></Icon>论坛
          </li>
          <li v-link="{ path: '/user/like' }">
            <Icon
              type="heart"
              class="menu-icon"
            ></Icon>{{ $t(`user.like`) }}
          </li>
          <li v-link="{ path: '/user/manage' }">
            <Icon
              type="navicon-round"
              class="menu-icon"
            ></Icon>{{ $t(`user.manage`) }}
          </li>
          <li v-link="{ name: 'u', params: { userid: info.userid } }">
            <Icon
              type="home"
              class="menu-icon"
            ></Icon>{{ $t(`user.personal`) }}
          </li>
          <li
            v-link="{ path: '/sell' }"
            class="divided"
          >
            <Icon
              type="paper-airplane"
              class="menu-icon"
            ></Icon>{{ $t(`operate.sell`) }}
          </li>
          <li v-link="{ name: 'secure' }">
            <Icon
              type="android-hand"
              class="menu-icon"
            ></Icon>{{ $t(`user.secure`) }}
          </li>
          <li
            v-link="{ path: '/user/logout' }"
            class="divided"
          >
            <Icon
              type="log-out"
              class="menu-icon"
            ></Icon>{{ $t(`user.logout`) }}
          </li>
        </ul>
      </li>
      <!-------- 用户登录后 end---------->

      <!-------- 用户签到 ---------->
      <li v-if="login">
        <a
          class="line"
          @click="this.signIn()"
        >

          <div>
            <Row>
              <p style ="font-size:15px;font-color:#FF0000">【签到】</p>
            </Row>
          </div>
        </a>
      </li>

      <!--------<li class="pc-only">------手机版显示新站点------>
        <a href="https://umiuni.com" target="_blank">
        <Icon
          class="icon"
        ></Icon>
        <span style="color: orange;">【新站点】</span>
        </a>
      <!----</li>---->

      <!-------- 当前学校/切换学校/默认学校 start---------->
      <li
        v-clickoutside="handleLocationClickOutside"
        class="right"
        font-color: 
      >
        <a
          class="line"
          @click="this.locationToggle = !this.locationToggle"
        >
          <!-- {{ $t('operate.switchSchool') }} -->
          <div>
            <Row>
              <p style ="font-size:15px;">【学校：{{school.abbr}}】<Icon type="ios-arrow-down"></Icon></p>
            </Row>
          </div>
        </a>
      </li>
      <ul
        v-if="school"
        class="card dropdown right"
        style="z-index:300; position:absolute; padding: 10px; text-align: center; margin-left:57%;margin-right:10%;height:auto;width:auto;"
        :class="{ active: locationToggle }"
        @click="locationToggle = false"
      >
        <p>当前学校: {{ school.name }}</p>
        <i-button
          long
          @click="setSchool(null)"
        >
          更改学校
        </i-button>
        <i-button
          long
          style="margin-top: 10px;"
          v-link="{ path: '/user/profile' }"
        >
          默认学校
        </i-button>
      </ul>
      <!-------- 当前学校/切换学校/默认学校 end---------->


      <!-- <li class="right mobile-only">
        <a><i-button
          type="primary"
          shape="circle"
          @click="searchToggle = !searchToggle"
        ><Icon type="search"></Icon> {{ $t(`operate.search`) }}</i-button></a>
      </li> -->
    </ul>
  </header>
  <!-- Mobile search disabled-->
  <!-- <div
    v-show="searchToggle && navFixed"
    class="mobile-dropdown mobile-only"
  >
    <div class="search-bar-container">
      <div class="search-bar">
        <a
          class="search-type"
          @click="typeMenuToggle = !typeMenuToggle"
        >
          {{ types[query.type] }}
        </a>
        <ul
          class="dropdown"
          :class="{ active: typeMenuToggle }"
          @click="typeMenuToggle = false"
        >
          <li
            v-for="type in keys(types)"
            @click="query.type = type"
          >
            <span v-link="{ name: 'search', query: { type: type } }">{{ types[type] }}</span>
          </li>
        </ul>
        <Icon
          v-if="!typeMenuToggle"
          type="ios-arrow-down"
        ></Icon>
        <Icon
          v-else
          type="ios-arrow-up"
        ></Icon>
        <input
          v-model="query.name"
          class="search-content"
          autocomplete="off"
          type="text"
          placeholder="名称"
        >
        <button
          v-link="{ name: 'search', query: query }"
          class="search-btn"
          data-market="搜索栏;搜索Button"
        >
          <Icon type="search"></Icon> {{ $t(`operate.search`) }}
        </button>
      </div>
    </div>
  </div> -->




  <!-- <div
    v-show="!searchToggle && navFixed"
    class="mobile-dropdown mobile-only"
  >
    <div class="wrapper">
      <div
        class="mobile-nav nav-category"
        :class="{ active: toggleNavActive}"
      >
        <a
          v-for="type in keys(types)"
          class="u-button"
          style="margin-right: 4%; width: 16%"
        ><span v-link="{ name: 'search', query: { type: type } }">{{ types[type] }}</span></a>
      </div>
    </div>
  </div> -->

  <div
    class="mobile-only qr-fixed-right"
    :class="{ active: toggleQRActive}"
  >
    <img
      src="../assets/qr_circle_wechat_mini_mobile_2021.jpg"
      width="240"
    >
  </div>

  <div
    v-if="info.authority == 2"
    style="position: fixed; left: 0; top: 0; z-index: 10001; padding: 3px;"
  >
    Admin
  </div>

  <ul class="mobile-nav mobile-only unselectable">
    <li>
      <a
        v-link="{ name: 'index' }"
        :class="{ active: $route.name === 'index' }"
      >
        <Icon
          type="ios-home-outline"
          class="icon"
        ></Icon>
        <span>主页</span>
      </a>
    </li>
    <li>
      <a
        v-link="{ name: 'search', query: { type: 'event' } }"
        :class="{ active: $route.name === 'secure' }"
      >
        <Icon
          type="beer"
          class="icon"
        ></Icon>
        <span>活动</span>
      </a>
    </li>
    <li>
      <a
        v-link="{ name: 'sell' }"
        :class="{ active: $route.name === 'sell' }"
      >
        <Icon
          type="ios-plus-empty"
          class="icon"
        ></Icon>
        <span>发布</span>
      </a>
    </li>
    <li>
      <a @click="classToggle = !classToggle">
        <Icon
          type="ios-pricetags-outline"
          class="icon"
        ></Icon>
        <span>分类</span>
      </a>
    </li>
    <li>
      <a
        v-link="{ path: '/user/nav' }"
        :class="{ active: $route.path.split('/')[1] === 'user' }"
      >
        <Icon
          type="ios-person-outline"
          class="icon"
        ></Icon>
        <span>账号管理</span>
      </a>
    </li>
  </ul>

  <div
    v-show="classToggle"
    slot="content"
    class="classification full float"
    transition="pull"
    @click.prevent="classToggle = false"
  >
    <ul class="dropdown">
      <li
        v-for="type in keys(types)"
        @click="query.type = type"
      >
        <div class="hr">
          <span v-link="{ name: 'search', query: { type: type } }">{{ types[type] }}</span>
        </div>
        <div
          v-if="tagList"
          class="tag-list"
        >
          <span
            v-for="tag in tagList[type]"
            v-link="{ name: 'search', query: { type: type, tag: tag } }"
          >{{ tag }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
import storeUser from '../vuex/store';
import { userUpdateInfo, setSchool } from '../vuex/actions';
import { isLogin, getUserInfo, getSchool, getTypes } from '../vuex/getters';
import api from '../api';
import clickoutside from '../directives/clickoutside';
import router from '../router';
import { EventBus } from '../utils/event-bus';
import { camelize } from '../utils/camelize';
import { extractErrorMessage } from '../utils/error';

export default {
  directives: { clickoutside },

  store: storeUser,
  vuex: {
    actions: {
      userUpdateInfo, setSchool,
    },
    getters: {
      login: isLogin,
      info: getUserInfo,
      school: getSchool,
      types: getTypes,
    },
  },

  data () {
    return {
      OSS: api.OSS,
      menuToggle: false,
      typeMenuToggle: false,
      searchToggle: true,
      tagList: null,
      query: {
        type: 'used',
        name: '',
      },
      classToggle: false,
      locationToggle: false,
      scrollTop: 0,
      navFixed: true,
      timer: null,
      toggleNavActive: true,
      toggleQRActive: false,
      splitedStr: "",
    };
  },

  computed: {
    ulStyle: function () {
      return this.$route.name === 'other' ? { maxWidth: '10000px', margin: '0 0 0 10px' } : {};
    },
    splitedList(el){
        let newArr = [...this.list]
      newArr.map(el => {
        return el.codes = el.codes.split('+')
      })
      return newArr
    }
  },

  watch: {
    login: {
      handler: function (val, oldVal) {
        if (val) {
          this.getInfo();
        }
      },
    },
    info: {
      deep: true,
      handler: function (val, oldVal) {
      },
    },
  },

  methods: {
    keys: Object.keys,
    camelize,

    toggleQR () {
      this.toggleQRActive = !this.toggleQRActive;
    },

    signIn () {
      if (this.info.userid) {
        this.$http.post(api.user.user_signin, {
            user_id: this.info.userid,
            session: this.info.session,
            signin_text:"Happy and hardwork another day",
        })
          .then((res) => {
              if(res.body.error){
                this.$Notice.error({
                  title: '签到失败!',
                  desc:  extractErrorMessage(res),
                  duration: 9,
                });
              } else if (res.body && res.body.userid) {
                const date = new Date(res.body.last_signin_time);
                const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                this.$Notice.success({
                  title: '签到成功!'+'签到经验:'+res.body.balance,
                  desc:  '上次签到时间：'+ formattedDate + '\n需要间隔1分钟',
                  duration: 9,
                });
              }
          }, (res) => {
            this.$Message.error('Fail: please retry:', res.body.error);
          });
      }
    },

    getInfo () {
      if (this.info.userid) {
        this.$http.get(api.user.getInfo, {
          params: {
            userid: this.info.userid,
          },
        })
          .then((res) => {
            if (res.body && res.body.username) {
              const info = Object.assign({}, {
                username: res.body.username,
                avatar: res.body.avatar,
                authority: res.body.authority,
              });
              this.userUpdateInfo(info);
            }
          });
      }
    },

    getTagList () {
      return this.$http.get(api.tag.list)
        .then((res) => {
          if (res.body) {
            this.tagList = res.body;
          }
        });
    },

    handleLocationClickOutside () {
      this.locationToggle = false;
    },

    handleMenuClickOutSide() {
      this.menuToggle = false;
    },

    handleScroll (e) {
      if (window.document.body.scrollTop < 200) {
        this.navFixed = true;
      } else if (this.scrollTop - window.document.body.scrollTop > 50) {
        this.navFixed = true;
        this.scrollTop = window.document.body.scrollTop;
      } else if (this.scrollTop - window.document.body.scrollTop < -50) {
        this.navFixed = false;
        this.scrollTop = window.document.body.scrollTop;
      }
    },

    search () {
      router.go({ name: 'search', query: this.query });
    },

    forumPost () {
      if (!this.login) {
        router.go({ name: 'login' });
        return;
      }
      if (this.$route.name !== 'forum-list') {
        router.go({ name: 'forum-list', params: { forumId: 'default' }, query: { new: 'true' } });
      }
      EventBus.$emit('forum-post');
    },
  },

  ready () {
    this.getTagList();
    this.$nextTick(() => {
      this.scrollTop = window.document.body.scrollTop;
      setTimeout(window.addEventListener('scroll', this.handleScroll, false), 1000);
    });
  },

  beforeDestory () {
    window.removeEventListener('scroll', this.handleScroll);
  },

   splitedStrFunction: function () {
		
		this.splitedStr = this.str.split(" ");
		
  },
	
};
</script>

<style scoped lang="less">
@import '../styles/const.less';

header, .mobile-dropdown {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;

    z-index: 100;

    background: #fff;

    font-size: 1.2em;

    box-shadow: 0 1px 1px rgba(0,0,0,.15);

    transform: translate(0, 0);;
    transition: transform 0.3s ease;
    &.fixed {
        @media screen and (max-width: 769px) {
            transform: translate(0, -50px);;
        }
    }

    &.mobile-dropdown {
        top: 50px;
        height: 3.5em;
    }

    & > ul {
        height: 100%;
        max-width: @centent-width;

        margin: 0 auto;

        & > li {
            vertical-align: middle;
            display: inline-block;

            &.right {
                float: right;
            }

            @margin: 5px;
            @margin-mobile: 3px;

            &:not(.right):not(:first-child) {
                margin-left: @margin;
            }

            &:not(.right):not(:last-child) {
                margin-right: @margin;
            }

            &.right:not(:first-child) {
                margin-right: @margin;
            }

            &.right:not(:last-child) {
                margin-left: @margin;
            }

            @media screen and (max-width: 767px) {
                &:not(.right):not(:first-child) {
                    margin-left: @margin-mobile;
                }

                &:not(.right):not(:last-child) {
                    margin-right: @margin-mobile;
                }

                &.right:not(:first-child) {
                    margin-right: @margin-mobile;
                }

                &.right:not(:last-child) {
                    margin-left: @margin-mobile;
                }
            }

            .menu-icon {
                display: inline-block;
                width: 20px;
            }

            a {
                height: 50px;
                line-height: 30px;
                text-align: center;
                @media screen and (max-width: 767px) {
                    font-size: 0.9em;
                }

                display: block;

                color: #222;

                padding: 10px 3px;
                @media screen and (max-width: 767px) {
                    padding: 10px 2px;
                }

                &.user > * {
                    vertical-align: middle;
                }

                & .avatar {
                    width: 30px;
                    height: 30px;

                    background-position: center;
                    background-size: cover;

                    display: inline-block;

                    border-radius: 100%;
                    border: solid 1px fade(#000, 30%);

                    margin: 0 5px 0 0;
                }

                &.line {

                    padding-top: 6px;
                    border-top: solid 4px fade(@primary-color, 0);

                    transition: border .3s ease;

                    &:hover {
                        border-top: solid 4px @primary-color;
                    }
                }

                &.button {

                    @button-margin: 6px;

                    height: 50px - 2 * @button-margin;
                    margin: @button-margin;
                    padding: 0 20px;
                    @media screen and (max-width: 767px) {
                        padding: 0 15px;
                    }
                    line-height: 50px - 2 * @button-margin;
                    border: solid 1px @primary-color;
                    border-radius: 4px;

                    font-weight: 500;
                    color: @primary-color;

                    &:hover {
                        background: @primary-color;
                        color: #fff;
                    }
                }
            }
        }
    }

    ul.dropdown {
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 1px 2px rgba(0,0,0,.2);
        margin-top: 5px;

        overflow: hidden;

        display: none;

        position: fixed;

        z-index: 9000;

        &.right {
            @media screen and (max-width: 769px) {
                right: 0;
            }
        }

        &.active{
            display: block;
        }
        li {
            margin: 0;
            padding: 7px 16px;
            color: #657180;
            font-size: 12px!important;
            cursor: pointer;
            transition: background .2s ease-in-out;
            list-style: none;
            white-space: nowrap;
            clear: both;
            &:hover {
                background: #f3f3f3;
            }

            &.divided {
                border-top: 1px solid #e3e8ee;
            }
        }
    }

    .search-bar-container {
        padding: 0 10px;
    }

    .search-bar {
        // border: solid 1px @divider-color;
        box-shadow: 0 -1px 0px rgba(0,0,0,.15);
        background: #f5f5f5;
        border-radius: 18px;
        height: 36px;

        padding-left: 9px;

        font-size: 11px;

        position: relative;

        margin: 5px 0;

        & > * {
            vertical-align: middle;
        }

        .search-type {
            display: inline-block;
            height: 36px;
            line-height: 30px;
            padding: 3px;

            width: 65px;

            text-align: center;
            color: #222;

            overflow: hidden;

            &:hover > .dropdown {
                display: block;
            }
        }

        .search-content {
            width: 100px;
            height: 36px;
            line-height: 36px;
            color: #343434;
            font-size: 1em;
            border: none;
            outline: 0;
            background: 0;
            font-size: 13px;
            padding-left: 10px;
        }

        .search-btn {
            display: inline-block;
            height: 26px;
            width: 64px;
            margin: 5px 5px 5px 10px;
            padding: 0;
            background: @primary-color;
            color: #fff;
            border-radius: 13px;
            line-height: 26px;
            border: none;
            outline: 0;
            text-align: center;
            cursor: pointer;

            float: right;

            &:hover {
                background: tint(@primary-color, 20%);
            }
        }

        .dropdown {
            margin: -1px 0 0 0;
        }
    }
}

.button-group {
    margin-right: -6px;
    .button {
        cursor: pointer;

        display: inline-block;

        @button-margin: 6px;

        height: 50px - 2 * @button-margin;
        margin: @button-margin;
        padding: 0 20px;
        @media screen and (max-width: 767px) {
            padding: 0 15px;
        }
        line-height: 50px - 2 * @button-margin;
        border: solid 1px @primary-color;
        border-radius: 19px;

        font-weight: 500;
        color: @primary-color;

        &:hover {
            background: @primary-color;
            color: #fff;
        }

        &:not(:last-child) {
            margin-right: -4px;

            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            border-right: 0;
        }
        &:not(:first-child) {
            margin-left: 0;

            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
}

.classification {
    &.float {
        position: fixed;
        bottom: 50px;
        left: 0;
        right: 0;
        z-index: 10000;

        .dropdown {
            padding: 10px;
            background: #fff;

            max-width: none;

            .tag-list > span {
                padding: 10px 15px 20px 15px;
                font-size: 1.3em;
            }
        }

        box-shadow: 0 -1.5px 1px rgba(0,0,0,.15);
    }
}

.classification > a {
    &:hover {
        & > .dropdown {
            display: block;
        }
    }
}

.classification .dropdown {
            margin: -1px 0 0 0;

            max-width: 270px;

            & > li {
                cursor: default;
                background: #fff;
            }

            .tag-list {
                display: block;
                overflow: hidden;

                span {
                    cursor: pointer;

                    padding: 8px 4px;
                    line-height: 1em;
                    display: inline-block;
                    float: left;

                    &:hover {
                        color: @primary-color;
                    }
                }
            }
}

.hr {
    border-bottom: solid 1px #9ea7b4;
    display: block;

    @height: 20px;

    height: @height / 2;
    margin: 0 0 ( @height / 2 + 10px ) ;

    position: relative;

    & > span {
        position: absolute;
        @width: 80px;
        width: @width;
        margin: 0 0 0 (-@width/2);
        left: 50%;
        top: 0;
        line-height: @height;
        height: @height;

        background: #fff;

        text-align: center;

        font-size: 1em;

        cursor: pointer;

        &:hover {
            color: @primary-color;
        }
    }
}

.mobile-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

    @height: 50px;

    height: @height;

    background: #fff;

    z-index: 10000;

    padding: 0;
    margin: 0;

    box-shadow: 0 -1.5px 1px rgba(0,0,0,.15);

    & > li {
        display: inline-block;
        width: 20%;
        float: left;

        height: @height;

        text-align: center;

        a {
            display: block;
            height: @height;
            // line-height: 50px;
            color: #555;

            padding: (@height - 40)/2 0;

            .icon {
                display: block;
                font-size: 25px;
                line-height: 25px;
            }

            span {
                font-size: 0.85em;
                line-height: 15px;
            }

            &.active {
                color: @primary-color;
            }
        }
    }
}

.nav-category {
    font-size: 1em;
    float:left;
    margin-top:4%;
    margin-left:1.5%;
    margin-right:1.5%;
    padding:4%;
    text-align: center;
    a {
        color: #666;
    }
}

.navigation-button {
    margin-top: 5%;
    position:relative;
    img {
        margin-top:2%;
    }
}

.pull-transition {
}
.pull-enter {
    animation: pull-in .3s;
}
.pull-leave {
    animation: pull-out .3s;
}

.u-button-list {
    text-align: center;
    display: none;
    margin-top: 6%;
    &.active {
        display: block;
    }
    position: absolute;
    z-index: 100;
    font-color: black;
    font-size: 1px;

    @height: 20px;

    & > a {
        display: inline-block;
        width: 20%;
        float: left;

        height: @height;

        text-align: center;

        a {
            display: block;
            height: @height;
            // line-height: 50px;
            color: #555;

            padding: (@height - 40)/2 0;

            .icon {
                display: block;
                font-size: 25px;
                line-height: 25px;
            }

            span {
                font-size: 0.85em;
                line-height: 15px;
            }

            &.active {
                color: @primary-color;
            }
        }
    }
}

.u-botton_line {
    display: block;
    height: 1px;
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);
}

.qr-fixed-right {
    position: fixed;
    display: none;
    margin: 40% 20% 75% 15%;
    &.active {
        display: block;
    }
    z-index: 100;
}

@keyframes pull-in {
    0% {
        opacity: 0;
        transform-origin: 100% 100%;
        transform: scaleY(0.8);
    }
    100% {
        opacity: 1;
        transform-origin: 100% 100%;
        transform: scaleY(1);
    }
}
@keyframes pull-out {
    0% {
        opacity: 1;
        transform-origin: 100% 100%;
        transform: scaleY(1);
    }
    100% {
        opacity: 0;
        transform-origin: 100% 100%;
        transform: scaleY(0.8);
    }
}

</style>



// WEBPACK FOOTER //
// Header.vue?0a07199f